export const teachingData = [
  {
    id: "berkeley",
    organization:
      "University of California, Berkeley: Electrical Engineering and Computer Sciences",
    location: "Berkeley, CA",
    role: "Adjunct Lecturer",
    timeline: "June 2026 - Present",
    description:
      "Summer co-lecturer for CS 160: User Interface Design and Development",
    highlights: [
      "Designed course curriculum to teach students the fundamentals of user interface and user experience design and web development",
      "Worked with co-lecturer to iterate on previous course curriculum and improve student experience",
      "Taught crucial topics such as HTML, CSS, JavaScript, as well as design process including needs-finding, prototyping, and user testing",
    ],
    images: [
      "/teaching/berkeley_1.png",
      "/teaching/berkeley_2.png",
      "/teaching/berkeley_3.png",
    ],
    buttons: [
      {
        label: "Course Website",
        link: "https://cs160-summer-2026.github.io/website/",
      },
    ],
  },
  {
    id: "lvsf",
    organization: "Lower Valley Scholars Foundation",
    location: "El Paso, TX",
    role: "Co-Founder & Director of Outreach",
    timeline: "May 2020 - July 2025",
    description:
      "Established foundation focused on helping first-generation, low-income, minority students from the Lower Valley area of El Paso achieve their educational goals.",
    highlights: [
      "Drafted founding documents and assisted with the legal documentation needed to become official non-profit",
      "Created resources for students in the form of slideshows, workshop presentations, and documents",
      "Worked with local businesses and entities to develop partnerships and sponsorships",
    ],
    images: [
      "/teaching/lvsf_1.jpg",
      "/teaching/lvsf_2.jpg",
      "/teaching/lvsf_3.jpg",
    ],
  },
  {
    id: "dinkelspiel",
    organization: "Stanford University Presidential Awards",
    location: "Stanford, CA",
    role: "Lloyd W. Dinkelspiel Award Recipient",
    timeline: "June 2024",
    description: "",
    highlights: [
      "Recipient of Dinkelspiel Award for service as RA, IDEAL pedagogy team member, and leader in Stanford Society of Latinx Engineers.",
      "Recognized for accessible CS teaching and support of underrepresented students through advocacy and resource-building.",
      "Honored for contributions to undergraduate education, community, and student life.",
    ],
    images: ["/teaching/dinkelspiel.png"],
    buttons: [
      {
        label: "Stanford Report Article",
        link: "https://news.stanford.edu/stories/2024/06/cuthbertson-dinkelspiel-and-gores-award-winners-announced",
      },
    ],
  },
  {
    id: "centennial",
    organization: "Stanford University Centennial Teaching Awards",
    location: "Stanford, CA",
    role: "Centennial Teaching Award Recipient",
    timeline: "May 2024",
    description:
      "The annual Centennial Teaching Assistant (CTA) Awards recognize outstanding teaching assistants (TAs) for their tremendous service and dedication in providing excellent classroom instruction for Stanford students. ",
    highlights: [
      "A committee of faculty selects winners from the pool of excellent TAs in the school as a result of extraordinary teaching.",
      "I was 1 of 20 TAs in the School of Engineering, and 1 of 6 TAs in the Computer Science department to receive this award.",
    ],
    images: ["/teaching/cta_1.JPG", "/teaching/cta_2.jpeg"],
    buttons: [
      {
        label: "List of Winners",
        link: "https://ctl.stanford.edu/grad-teaching/ta-award/winners#2024-winners",
      },
    ],
  },
  {
    id: "cs278",
    organization: "Stanford Computer Science Department",
    location: "Stanford, CA",
    role: "Head Teaching Assistant – CS 278: Social Computing",
    timeline: "April 2024 - June 2024",
    description:
      "Managed a teaching team of 10 and worked closely with Prof. Michael Bernstein to ensure the course flowed smoothly.",
    highlights: [
      "Assisted with exam creation, website management, course design, grading, and student concerns",
      "Covered topics such as virality, feed ranking, peer production, moderation, misinformation, and social factors of computing",
      "Supported a class of 295 students",
    ],
    images: ["/teaching/cs278.png"],
    buttons: [
      {
        label: "Course Website",
        link: "https://web.stanford.edu/class/cs278/",
      },
    ],
  },
  {
    id: "cs107",
    organization: "Stanford Computer Science Department",
    location: "Stanford, CA",
    role: "Teaching Assistant – CS 107: Computer Organization and Systems",
    timeline: "January 2024 - March 2024",
    description:
      "Taught the C language and computer systems concepts including Unix, memory allocation, and pointer arithmetic.",
    highlights: [
      "Graded assignments, reviewed code, and ran office hours",
      "Supported a class of 255 students",
    ],
    images: ["/teaching/cs107.png"],
    buttons: [
      {
        label: "Course Website",
        link: "https://web.stanford.edu/class/archive/cs/cs107/cs107.1244/index.html",
      },
    ],
  },
  {
    id: "cs148",
    organization: "Stanford Computer Science Department",
    location: "Stanford, CA",
    role: "Teaching Assistant – CS 148: Intro to Computer Graphics",
    timeline: "September 2023 - December 2023",
    description:
      "Helped students explore introductory computer graphics concepts such as light, shading, and ray tracing.",
    highlights: [
      "Assisted students with final projects in Blender",
      "Supported a class of 488 students",
    ],
    images: ["/teaching/cs148.png"],
    buttons: [
      {
        label: "Course Website",
        link: "https://web.stanford.edu/class/cs148/",
      },
    ],
  },
  {
    id: "solelair",
    organization: "Stanford Society of Latinx Engineers",
    location: "Stanford, CA",
    role: "Co-Founder & Volunteer – SOLE LaIR",
    timeline: "January 2023 - June 2024",
    description:
      "Established a peer support program for Latinx students in introductory computer science courses.",
    highlights: [
      "Provided individualized debugging and conceptual support",
      "Extended traditional LaIR office hours to underrepresented groups in STEM",
    ],
    images: ["/teaching/soleLair.jpeg"],
  },
  {
    id: "ssea",
    organization: "Stanford School of Engineering",
    location: "Stanford, CA",
    role: "Lecturer – CS 106A: Programming Methodology",
    timeline: "August 2023",
    description:
      "Served as the main lecturer for the Stanford Summer Engineering Academy's introductory computer science course.",
    highlights: [
      "Created assignments to test Python coding fundamentals",
      "Managed course website and monitored Ed platform",
    ],
    images: [
      "/teaching/ssea_1.png",
      "/teaching/ssea_2.png",
      "/teaching/ssea_3.png",
    ],
    buttons: [
      {
        label: "SSEA Website",
        link: "https://engineering.stanford.edu/students-academics/student-success-and-engagement/undergraduate-programs/stanford-summer",
      },
    ],
  },
  {
    id: "honorsThesis",
    organization: "Stanford Graduate School of Education",
    location: "Stanford, CA",
    role: "Undergraduate Honors Thesis Researcher",
    timeline: "September 2022 - June 2023",
    description:
      "Conducted an honors thesis on how marginalized students perceive and engage with cultural centers at Stanford, exploring identity, belonging, and inclusion through a mixed-methods approach.",
    highlights: [
      "Advised by Dr. Ramon Martinez and Dr. Ari Y. Kelman",
      "Designed and administered surveys with both quantitative Likert-scale and qualitative open-ended questions",
      "Identified key themes around community, cultural pride, intersectionality, and programming improvements",
      "Bridged gaps in research on the role of cultural centers in fostering inclusion within elite institutions",
    ],
    images: ["/teaching/thesis.png"],
    buttons: [
      {
        label: "Read Full Thesis",
        link: "https://purl.stanford.edu/sh539kz3178",
      },
      {
        label: "Google Scholar",
        link: "https://scholar.google.com/citations?user=6zyhkssAAAAJ",
      },
    ],
  },
  {
    id: "cs106",
    organization: "Stanford Computer Science Department",
    location: "Stanford, CA",
    role: "Section Leader – CS 106A/106B",
    timeline: "September 2021 - June 2023",
    description:
      "Led weekly discussion sections and provided conceptual/debugging support for students in introductory programming courses.",
    highlights: [
      "Started DEI initiative of weekly office hours for first-gen and low-income students",
      "Monitored Ed Platform as Head TA for Stanford Summer Engineering Academy",
      "Taught introductory topics in Spanish through CS Bridge in Bogotá, Colombia",
    ],
    images: ["/teaching/sl_1.png", "/teaching/sl_2.png", "/teaching/sl_3.jpeg"],
    buttons: [
      {
        label: "CS 106A Website",
        link: "https://web.stanford.edu/class/cs106a/",
      },
      {
        label: "CS 106B Website",
        link: "https://web.stanford.edu/class/cs106b/",
      },
    ],
  },
  {
    id: "cip",
    organization: "Stanford Code in Place",
    location: "Remote",
    role: "Section Leader",
    timeline: "April 2021 - May 2021",
    description:
      "Volunteer section leader for Stanford’s global research project version of CS 106A: Programming Methodology.",
    highlights: [
      "Worked with 50+ teaching leads and 1000 section leaders to support 10,000+ students worldwide",
      "Prepared and taught weekly sections of 10 students",
    ],
    images: ["/teaching/cip.png"],
    buttons: [
      {
        label: "Course Website",
        link: "https://codeinplace.stanford.edu/",
      },
    ],
  },
  {
    id: "ctl",
    organization: "Stanford Center for Teaching and Learning",
    location: "Stanford, CA",
    role: "Program Development Associate",
    timeline: "January 2021 - September 2022",
    description:
      "Developed materials for IDEAL Pedagogy, a program aimed at inclusivity and diversity in higher education.",
    highlights: [
      "Created asynchronous modules, designed website, and developed partnerships",
    ],
    buttons: [
      {
        label: "Program Poster",
        link: "https://cdn.serc.carleton.edu/files/ASCN/transforming_institutions/2021/program/posters/session_a/1/melissa_ko_poster_transforming_institutions_conference.pdf",
      },
    ],
  },
  {
    id: "mtc",
    organization: "Our Lady of Mt. Carmel Catholic Church",
    location: "El Paso, TX",
    role: "Teacher’s Assistant",
    timeline: "September 2011 - May 2019",
    description:
      "Assisted with lesson planning, material preparation, and teaching for 3rd grade students.",
  },
];
